import CONFIG from "../../config/config";
import { Card, CardBody, CardHeader } from "../card/card";
import { useState } from "react";
import useKeyboardShortcut from "../../hooks/useKeyboardShortcut";

// Component for voiceover input
const VoiceoverCard = ({ label, voiceover, onTextChange, onGenerateVoice, shortcutModifier }) => {
    const [loading, setLoading] = useState(false); // State to track loading
    const [audioKey, setAudioKey] = useState(Date.now()); // Unique key for audio element
    const handleGenerateVoice = async () => {
        setLoading(true); // Set loading to true when generating voice
        try {
            const response = await onGenerateVoice();
            // Update the audio key to force the browser to reload the audio
            setAudioKey(Date.now());
        } catch (error) {
            console.error("Error generating voice:", error);
        } finally {
            setLoading(false); // Set loading to false after completion
        }
    };
    useKeyboardShortcut({ handler: handleGenerateVoice, key: "v", modifier: shortcutModifier }); // Keyboard shortcut for generating voice

    // Set default value for voiceover.text if it's not present
    const textValue = voiceover?.text || "";

    return (
        <Card>
            <CardHeader>
                <h5>{label}</h5>
            </CardHeader>
            <CardBody>
                <textarea
                    className="form-control mb-2"
                    value={textValue}
                    onChange={(e) => onTextChange(e.target.value)}
                    placeholder="Voiceover Text"
                ></textarea>
                <button
                    className="btn btn-success w-100"
                    onClick={handleGenerateVoice}
                    disabled={loading} // Disable button when loading
                >
                    {loading ? (
                        <>
                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            <span className="ms-2">Generating...</span>
                        </>
                    ) : (
                        "Generate Voice"
                    )}
                </button>
                {voiceover?.voice && (
                    <audio controls className="mt-2 w-100" key={audioKey}>
                        <source src={`${CONFIG.VOICE_BASE_URL}/${voiceover.voice}?key=${audioKey}`} type="audio/mpeg" />
                    </audio>
                )}
            </CardBody>
        </Card>
    );
};

export default VoiceoverCard;